import { ViewerNode } from '../models/graph-viewer.models';
import { collectMergedPlatformDisplayFields, canonicalFieldKey, uniqueCanonicalValues } from '../../../../utils/canonical-field-key';

/** Only returned source data is eligible; the search query is not an identity result. */
export function serviceNodePrimaryValue(node: ViewerNode): string {
  const meta = node.raw?.metadata ?? {};
  const fields = collectMergedPlatformDisplayFields(meta.sourceData ?? {});
  const buckets = new Map<string, unknown[]>();
  const add = (key: string, values: unknown): void => {
    const normalized = canonicalFieldKey(key);
    buckets.set(normalized, [...(buckets.get(normalized) ?? []), ...uniqueCanonicalValues(values)]);
  };
  fields.forEach(field => add(field.key, field.values));
  const visit = (value: unknown, depth: number): void => {
    if (!value || typeof value !== 'object' || depth > 5) return;
    if (Array.isArray(value)) { value.forEach(item => visit(item, depth + 1)); return; }
    Object.entries(value).forEach(([key, item]) => {
      add(key, item);
      visit(item, depth + 1);
    });
  };
  visit(meta.sourceData, 0);
  for (const source of [meta.searchable, meta.searchableValues, node.details]) {
    if (source && typeof source === 'object') Object.entries(source).forEach(([key, value]) => add(key, value));
  }
  add('name', meta.extractedNames);
  const priorities = [
    ['name', 'full_name', 'fullname', 'real_name', 'customer_name', 'subscriber_name'],
    ['phone', 'phone_number', 'mobile', 'mobile_number', 'telephone'],
    ['email', 'email_address'], ['email_hint', 'email_address_hint', 'masked_email'],
    ['username', 'handle', 'vpa'], ['id', 'user_id'],
  ];
  for (const keys of priorities) {
    for (const key of keys) {
      const value = buckets.get(key)?.find(item =>
        (typeof item === 'string' || typeof item === 'number') &&
        !/^(?:n\/?a|null|undefined|unknown|none|not found|true|false|account found|no account found)$/i.test(String(item).trim()));
      if (value != null) return String(value).replace(/\s+/g, ' ').trim();
    }
  }
  return '';
}
